import { BaseApiService } from '@/services/base-service';
import {
  ApiPagination, BaseResponse, Filters, FiltersPagination, Response,
} from '@/types';
import { NewsStatuses } from '@/enums';
import { News } from '../types';

interface NewsList extends BaseResponse, ApiPagination {
  data: {
    items: News.News[],
  }
}

export class NewsService extends BaseApiService {
  private readonly base_path = 'news';

  async get_news(filters: FiltersPagination<Filters>): Promise<NewsList> {
    const payload = filters;

    const { data } = await this.http_client.get<NewsList>(this.base_path, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_news_by_id(id: string | number): Promise<Response<News.News>> {
    const url = `${this.base_path}/${id}`;

    const { data } = await this.http_client.get<Response<News.News>>(url);

    return data;
  }

  async send_stats_by_id(id: string | number, type: string): Promise<BaseResponse> {
    const url = `${this.base_path}/${id}/stats`;

    const { data } = await this.http_client.post<Response<BaseResponse>>(url, { type });

    return data;
  }
}

export const default_news = (): News.News => ({
  id: 0,
  type: {
    id: 0,
    name: '',
    slug: NewsStatuses.EVENT,
  },
  image_path: '',
  title: '',
  preview_text: '',
  published_at: '',
  start_event_date: '',
  end_event_date: '',
  event_time: '',
  location: '',
});
